import React, { forwardRef } from 'react';
import classNames from 'classnames';

export interface SwitcherProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange' | 'size'> {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean, e: React.ChangeEvent<HTMLInputElement>) => void;
  checkedContent?: React.ReactNode;
  unCheckedContent?: React.ReactNode;
  color?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Switcher = forwardRef<HTMLInputElement, SwitcherProps>(
  (
    {
      className,
      checked,
      defaultChecked,
      disabled,
      onChange,
      checkedContent,
      unCheckedContent,
      color,
      size = 'md',
      id,
      ...rest
    },
    ref
  ) => {
    const inputId = id || `switcher-${Math.random().toString(36).substr(2, 9)}`;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked, e);
    };

    const sizeClasses = {
      sm: 'ecme-switcher-sm',
      md: '',
      lg: 'ecme-switcher-lg',
    };

    return (
      <label
        htmlFor={inputId}
        className={classNames(
          'ecme-switcher-wrapper',
          { disabled },
          className
        )}
      >
        <input
          ref={ref}
          id={inputId}
          type="checkbox"
          className="ecme-switcher-input"
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={handleChange}
          {...rest}
        />
        <span
          className={classNames('ecme-switcher', sizeClasses[size])}
          style={color && checked ? { backgroundColor: color } : undefined}
        >
          <span className="ecme-switcher-toggle" />
          {(checkedContent || unCheckedContent) && (
            <span className="ecme-switcher-content">
              {checked ? checkedContent : unCheckedContent}
            </span>
          )}
        </span>
      </label>
    );
  }
);

Switcher.displayName = 'Switcher';

export default Switcher;
